import React from 'react';
import { Flex, FlexItem, Stack, StackItem, Banner } from '@patternfly/react-core';
import BeaconTowerBreadcrumb from '../Breadcrumb/Breadcrumb';
import PropTypes from 'prop-types';
import styles from './ContentPage.module.css';
import HelpButton from '../../Help/HelpButton';

const BreadcrumPropType = PropTypes.shape({
  link: PropTypes.string,
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  displayName: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
});
const BannerType = PropTypes.shape({
  message: PropTypes.string,
  variant: PropTypes.stringC
});
/**
 * @typedef {Object} ContentPageProps
 * @prop {string} [title]
 * @prop {BreadcrumPropType[]} breadcrumb
 * @prop {React.ReactNode} [toolbar]
 * @prop {string} help
 * @prop {React.ReactNode} [children]
 * @prop {BannerType} [banner]
 */
/**
 *
 * @param {ContentPageProps} props
 * @returns {JSX.Element}
 */
const ContentPage = ({ title, breadcrumb, toolbar, help, children, banner = null }) => {
  return (
    <Stack className={styles.adminPageMain}>
      <StackItem >
        <Flex className={styles.contentHeader}>
          <FlexItem><BeaconTowerBreadcrumb text={title} items={breadcrumb}/></FlexItem>
          <FlexItem align={{ default: 'alignRight' }}>{ toolbar }</FlexItem>
          <FlexItem ><HelpButton file={help} /></FlexItem>
        </Flex>
      </StackItem>
      { banner && <StackItem><Banner variant={banner.variant}>{ banner.message }</Banner></StackItem> }
      <StackItem className={styles.adminPageContent}>
        { children }
      </StackItem>
    </Stack>
  );
};

ContentPage.propTypes = {
  title: PropTypes.string,
  breadcrumb: PropTypes.arrayOf(BreadcrumPropType),
  help: PropTypes.string,
  children: PropTypes.node,
  toolbar: PropTypes.node,
  banner: BannerType
};

export default React.memo(ContentPage);
